import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=e1cb98b2&scoped=true"
import script from "./ApprovalsTable.vue?vue&type=script&lang=js"
export * from "./ApprovalsTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsTable.vue?vue&type=style&index=0&id=e1cb98b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb98b2",
  null
  
)

export default component.exports